import React from 'react';
import { compose, withHandlers, withProps, withState } from 'recompose';

import { assignMemberships } from '../actions';
import confirmModal from '../../../common/confirmModal';
import withNotifications from '../../../common/withNotifications';
import {
  isItemChanged,
  getShopAssignments,
  getAssignedItemNames,
  getAssignmentPayload,
  getUnassignedItemNames,
} from './utils';

const withAssignmentHandlers = compose(
  withNotifications,
  withState('shopAssignments', 'setShopAssignments', props => getShopAssignments(props.items)),
  withState('busy', 'setBusy', false),
  withHandlers({
    toggleAssignment: props => (item) => {
      if (!item.canBeAssigned) {
        props.addNotification({
          title: 'Can\'t unassign the location',
          level: 'warning',
          message: `This location has ${item.counts.active} active members subscribed to this package and can’t be unassigned.`,
        });

        return;
      }

      props.setShopAssignments({
        ...props.shopAssignments,
        [item.shopId]: !props.shopAssignments[item.shopId],
      });
    },
    saveAssignments: props => async () => {
      const payload = getAssignmentPayload(props.items, props.shopAssignments);
      const assignedNames = getAssignedItemNames(payload);
      const unassignedNames = getUnassignedItemNames(payload);

      const confirmed = await confirmModal({
        type: 'yesno',
        title: 'Assign locations',
        message: (
          <div className="u-fontsize-normal">
            <div display-if={assignedNames}><b>{assignedNames}</b> will be assigned to this membership.</div>
            <div display-if={unassignedNames}><b>{unassignedNames}</b> will be unassigned from this membership.</div>
            <div>Confirm this assignment below.</div>
          </div>
        ),
        confirmButtonText: 'Assign',
        negativeButtonText: 'Cancel',
      });

      if (confirmed) {
        props.setBusy(true);
        try {
          const membership = await assignMemberships(props.ownerId, props.membership.id, payload);
          props.setMembership(membership);
          props.addNotification({
            title: 'Success',
            level: 'success',
            message: payload.length === 1 ? 'Location was assigned!' : 'Locations were assigned!',
          });
        } finally {
          props.setBusy(false);
        }
      }
    },
  }),
  withProps(props => ({
    canSaveAssignment: props.items.some(item => isItemChanged(item, props.shopAssignments)),
  })),
);

export default withAssignmentHandlers;
